import React from 'react';
import Header from '../Header/Header';
import { Container, Typography } from '@mui/material';

const DataPrivacy = () => {
  return (
    <>
      <Header />
      <Container>
        <Typography variant="h4">Data Privacy</Typography>
        Add your data privacy content here using Material UI components 
      </Container>
    </>
  );
};

export default DataPrivacy;